import { useMemo } from 'react';
import {
  getIsCoinbaseInjected,
  getIsMetaMaskInjected,
  getIsOKXInjected,
  getIsTrustWalletInjected,
} from '@ankr.com/provider';

interface UseIsMetamaskAvailableResult {
  disabled: boolean;
  injected: boolean;
}

export function useIsDesktopMetamaskAvailable(): UseIsMetamaskAvailableResult {
  return useMemo(() => {
    const isCoinbaseInjected = getIsCoinbaseInjected();
    const isOKXInjected = getIsOKXInjected();
    const isMetamaskInjected = getIsMetaMaskInjected();
    const isTrustWalletInjected = getIsTrustWalletInjected();

    const isOverriddenByCoin98 = !!window?.ethereum?.isCoin98;

    const isOverriddenByCoinbase = isCoinbaseInjected;
    const isOverriddenByOKX = isOKXInjected;
    const isOverriddenByTrustWallet =
      isTrustWalletInjected && !isMetamaskInjected;

    const isOverridden =
      isOverriddenByCoin98 ||
      isOverriddenByCoinbase ||
      isOverriddenByOKX ||
      isOverriddenByTrustWallet;

    return {
      disabled: isOverridden,
      injected: isMetamaskInjected,
    };
  }, []);
}
